import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import { formatNullable } from "../../../../../../common/src/util/dataUtil";
import config from "../../../../../../server/src/config";

import * as AdminActions from "../../../../actions/admin";
import {hasCommonProps} from "../../../../utils/Util";

export const defaultState = {
    Sektionsnr: '',
    Navn: '',
    WebSite: '',
    Bank: '',
    Regnr: '',
    Kontonr: '',
};

class SectionGeneral extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool,
        section: PropTypes.object,
    };

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.getStateFromStore(props));
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.editMode || ((nextProps.section === null && this.props.section !== null) || (nextProps.section !== null && (this.props.section === null || this.props.section.Sektionsnr !== nextProps.section.Sektionsnr)))) this.setState(this.getStateFromStore(nextProps));
    }

    getStateFromStore(props) {
        if (props.section === null)
            return defaultState;
        else {
            const section = props.section;
            return {
                Sektionsnr: section.Sektionsnr === null ? '' : section.Sektionsnr,
                Navn: section.Navn === null ? '' : section.Navn,
                WebSite: section.WebSite === null ? '' : section.WebSite,
                Bank: section.Bank === null ? '' : section.Bank,
                Regnr: section.Regnr === null ? '' : section.Regnr,
                Kontonr: section.Kontonr === null ? '' : section.Kontonr,
            }
        }
    }

    fields = [];
    render() {
   /*     const updateReq = this.props.club === null ? null : this.props.club.UpdateRequests.find(req => req.type === 'club') || null;
        const updates = updateReq === null || updateReq.updates === null ? {} : JSON.parse(updateReq.updates);*/
        const editMode = this.props.editMode;
        return <div className={"form-page club-general " + (editMode ? "editable" : "read-only")}>
            <table className="main-form-table">
                <tbody>
                <tr className="normal-row">
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Sektionsnr">Sektionsnr</label></span></td>
                    <td className={"data-cell"}>
                        {editMode ?
                            <UserFieldElement
                                dataType={UserFieldDataType.regex}
                                placeholder=""
                                className="field-1 small-field"
                                containerClassName="display-inline-block"
                                name="Sektionsnr"
                                id="Sektionsnr"
                                maxLength="2"
                                options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                                value={this.state.Sektionsnr}
                                autoCheckErrors={true}
                                required={true}
                                hideErrWhenFocused={true}
                                hideErrUntilFocused={true}
                                onChange={this.onStandardFieldChange}
                                ref={instance => { this.fields[0] = instance; }}
                            />
                            : <span className="value-text">{this.state.Sektionsnr}</span>
                        }
                    </td>
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Navn">Sektionsnavn</label></span></td>
                    <td className={"data-cell"}>
                        {editMode ?
                            <UserFieldElement
                                dataType={UserFieldDataType.string}
                                placeholder=""
                                className="field-1 medium-field"
                                containerClassName="display-inline-block"
                                name="Navn"
                                id="Navn"
                                value={this.state.Navn}
                                autoCheckErrors={true}
                                required={true}
                                hideErrWhenFocused={true}
                                hideErrUntilFocused={true}
                                onChange={this.onStandardFieldChange}
                                ref={instance => { this.fields[1] = instance; }}
                            />
                            : <span className="value-text">{this.state.Navn}</span>}
                    </td>
                </tr>
                <tr className="normal-row">
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Navn">Hjemmeside</label></span></td>
                    <td className={"data-cell"} colSpan={3}>
                        {editMode ?
                            <UserFieldElement
                                dataType={UserFieldDataType.string}
                                placeholder=""
                                className="field-1 large-field"
                                name="WebSite"
                                id="WebSite"
                                value={this.state.WebSite}
                                autoCheckErrors={true}
                                hideErrWhenFocused={true}
                                hideErrUntilFocused={true}
                                onChange={this.onStandardFieldChange}
                                ref={instance => { this.fields[2] = instance; }}
                            />
                            : <span className="value-text">{this.state.WebSite}</span>
                        }
                    </td>
                </tr>
                <tr className="normal-row">
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Bank">Bank</label></span></td>
                    <td className={"data-cell"} colSpan={3}>
                        {editMode ?
                            <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="field-1 large-field"
                                                      name="Bank" id="Bank" maxLength="35" value={this.state.Bank}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[3] = instance; }}
                            />
                            : <span className="value-text">{this.state.Bank}</span>
                        }
                    </td>
                </tr>
                <tr className="normal-row">
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Regnr">Reg.nr</label></span></td>
                    <td className={"data-cell"}>
                        {editMode ?
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 small-field" containerClassName="display-inline-block"
                                                      name="Regnr" id="Regnr" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]} value={this.state.Regnr}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[4] = instance; }}
                            />
                            : <span className="value-text">{this.state.Regnr}</span>
                        }
                    </td>
                    <td className={"label-cell"}><span className="label-text"><label htmlFor="Kontonr">Kontonr</label></span></td>
                    <td className={"data-cell"}>
                        {editMode ?
                            <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 medium-field" containerClassName="display-inline-block"
                                                      name="Kontonr" id="Kontonr" maxLength="14" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{1,14}"}]} value={this.state.Kontonr}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[5] = instance; }}
                            />
                            : <span className="value-text">{this.state.Kontonr}</span>
                        }
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = (onSuccess = null) => {
        if (this.allInputValid()) {
            const entity = {
                Sektionsnr: this.state.Sektionsnr,
                Navn: this.state.Navn,
                WebSite: this.state.WebSite === '' ? null : this.state.WebSite,
                Bank: this.state.Bank === '' ? null : this.state.Bank,
                Regnr: this.state.Regnr === '' ? null : this.state.Regnr,
                Kontonr: this.state.Kontonr === '' ? null : this.state.Kontonr,
            };
            if (this.props.section === null) this.props.dispatch(AdminActions.createSection(entity, onSuccess));
            else this.props.dispatch(AdminActions.updateSection(this.props.section.Sektionsnr, entity, onSuccess));
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    admin: {
        zipCodes: state.admin.zipCodes,
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(SectionGeneral);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/section/subPages/SectionGeneral.js